import { ProductionPiece } from 'app/models/ProductionPiece';
import { getPickingDescription } from './getPickingDescription';
import { createComparePickingPresentationPieces } from './comparePickingPresentationPieces';

interface AggregatePiecesByReferenceOptions {
  forceDrawerHardwareSorting?: boolean;
  // Keep the incoming order (already ordered before pagination).
  preserveOrder?: boolean;
}

export const aggregatePiecesByReference = (
  pieces: ProductionPiece[],
  options: AggregatePiecesByReferenceOptions = {},
): ProductionPiece[] => {
  const aggregated = new Map<string, ProductionPiece>();

  pieces.forEach(piece => {
    if (!piece) return;
    const key = JSON.stringify([
      piece.reference,
      piece.product?.cabinet != null ? piece.product.id : null,
      getPickingDescription(piece),
    ]);
    const existing = aggregated.get(key);
    if (existing) {
      aggregated.set(key, {
        ...existing,
        quantity: existing.quantity + piece.quantity,
      });
    } else {
      aggregated.set(key, { ...piece });
    }
  });

  const aggregatedPieces = Array.from(aggregated.values());

  if (options.preserveOrder) return aggregatedPieces;

  return aggregatedPieces.sort(
    createComparePickingPresentationPieces(options),
  );
};

export default aggregatePiecesByReference;
